import { Request, Response } from 'superagent';

export function superagentToPromise(req: Request): Promise<Response> {
  return new Promise((resolve, reject) => {
    req.end((err, res) => {
      if (err) {
        reject(err);
      } else {
        resolve(res);
      }
    });
  });
}

export function superagentRequestToAPIPromise(req: Request): Promise<any> {
  return new Promise((resolve, reject) => {
    req.end((err, res) => {
      if (err || !res.body || !res.body.status) {
        if (err && err.response && err.response.body && err.response.body.status) {
          reject(err.response.body);
        }
        if (err instanceof Error) {
          reject(err);
        }
        if (res && !res.body) {
          reject(new Error(`Unexpected Network Error: ${res.status}`));
        }
        return;
      }

      resolve(res.body.data);
    });
  });
}

export function waitAtLeast<T>(time: number, promise: Promise<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    let resolved = false;
    let rejected = false;
    let complete = false;
    let value: T;
    let error: Error;

    let timeout = setTimeout(() => {
      if (resolved) {
        resolve(value);
      } else if (rejected) {
        reject(error);
      } else {
        complete = true;
      }
    }, time);

    promise
      .then((_value) => {
        if (complete) {
          resolve(value);
        } else {
          resolved = true;
          value = _value;
        }
      })
      .catch((_error) => {
        if (complete) {
          reject(value);
        } else {
          rejected = true;
          error = _error;
        }
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/superagent.ts